import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { IconButton, Tooltip } from '@mui/material';

import { getTypeOfUser, pharmacyBillingSelector, TypeOfUser } from '@pharmaplan/common';
import useDrawerNavigation from '../../../../hooks/useDrawerNavigation';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import strings from '../../../../localization';
import useShowPaymentDialogs from '../../../../hooks/Payment/useShowPaymentDialogs';
import useSelfService from '../../../../hooks/useSelfService';

import styles from './styles';

const ToolbarAdd = () => {
  const { openAddDefaultDrawer } = useDrawerNavigation();
  const { isSelfService } = useSelfService();
  const { actionRequiredDialog } = useShowPaymentDialogs();

  const userType = useAppSelector(getTypeOfUser);
  const isPharmacy = userType === TypeOfUser.pharmacy;

  const billing = useAppSelector(pharmacyBillingSelector);
  const { creditCardLast4 } = billing ?? {};

  let title = strings.addAvailabilityVacation;

  if (isPharmacy) {
    title = strings.addWorkshifts;
  }

  const add = () => {
    if (isSelfService && !creditCardLast4 && isPharmacy) {
      actionRequiredDialog();
      return;
    }
    openAddDefaultDrawer();
  };

  return (
    <IconButton id="availabilties" onClick={add}>
      <Tooltip title={title}>
        <AddIcon sx={styles.icon} />
      </Tooltip>
    </IconButton>
  );
};

export default ToolbarAdd;
